const JANUARY = 'JANUARY';
const FEBRUARY = 'FEBRUARY';
const MARCH = 'MARCH';
const APRIL = 'APRIL';
const MAY = 'MAY';
const JUNE = 'JUNE';
const JULY = 'JULY';
const AUGUST = 'AUGUST';
const SEPTEMBER = 'SEPTEMBER';
const OCTOBER = 'OCTOBER';
const NOVEMBER = 'NOVEMBER';
const DECEMBER = 'DECEMBER';
export const FISCAL_OFFSET_MAP = {
  [JANUARY]: 0,
  [FEBRUARY]: 1,
  [MARCH]: 2,
  [APRIL]: 3,
  [MAY]: 4,
  [JUNE]: 5,
  [JULY]: 6,
  [AUGUST]: 7,
  [SEPTEMBER]: 8,
  [OCTOBER]: 9,
  [NOVEMBER]: 10,
  [DECEMBER]: 11
};